import { isNull } from 'lodash';
import { isEqual } from 'lodash/fp';

import { ApplicationState } from '../../../../store/types';
import { GraphKeyAndColour } from '../../../shared/analytics/PieChart';
import { getPortfolioRoot } from '../../store/selectors';
import { PortfolioQuestion, PortfolioDocumentField, PortfolioQuestionResponse, PortfolioAnalysisSurveySummary, PortfolioAnalysisPage, PortfolioAnalysisTemplate, PortfolioAnalyticsReportEmail } from './types';

export const getPortfolioQuestion = (state: ApplicationState): PortfolioQuestion => getPortfolioRoot(state).portfolioQuestion;

export const getDocumentFields = (state: ApplicationState): PortfolioDocumentField[] => getPortfolioRoot(state).availableFields;

export const getPortfolioResponse = (state: ApplicationState): PortfolioQuestionResponse | null => getPortfolioRoot(state).questionResponse;

export const getIsAskingQuestion = (state: ApplicationState): boolean => getPortfolioRoot(state).isAskingQuestion;

export const getIsChangingQuestion = (state: ApplicationState): boolean => getPortfolioRoot(state).isChangingQuestion;

export const getDownloadFilename = (state: ApplicationState): string | null => getPortfolioRoot(state).downloadFilename;

export const getGraphKeyColours = (state: ApplicationState): GraphKeyAndColour => getPortfolioRoot(state).graphKeyColours;

export const getPieChartBase64 = (state: ApplicationState): string => getPortfolioRoot(state).pieChartBase64;

export const getIsDownloadingResults = (state: ApplicationState): boolean => getPortfolioRoot(state).isDownloading;

export const getSurveySummary = (state: ApplicationState): PortfolioAnalysisSurveySummary => getPortfolioRoot(state).surveySummary;

export const getPortfolioAnalysisPageView = (state: ApplicationState): PortfolioAnalysisPage => getPortfolioRoot(state).pageView;

export const getPortfolioAnalyticsTemplates = (state: ApplicationState): PortfolioAnalysisTemplate[] => getPortfolioRoot(state).templates;

export const getSurveyIndex = (state: ApplicationState): number => getPortfolioRoot(state).surveyIndex;

export const getPortfolioAnalyticsTemplateUsed = (state: ApplicationState): PortfolioAnalysisTemplate | null => getPortfolioRoot(state).templateUsed;

export const getPortfolioAnalyticsTemplateUsedHasUpdated = (state: ApplicationState): boolean => {

    const template = getPortfolioAnalyticsTemplateUsed(state);
    const currentQuestion = getPortfolioQuestion(state);
    if (isNull(template)) {
        return false;
    }
    return !isEqual(template.metaData, currentQuestion);
};

export const getIsFetchingTemplates = (state: ApplicationState): boolean => getPortfolioRoot(state).isFetchingTemplates;

export const getReportEmail = (state: ApplicationState): PortfolioAnalyticsReportEmail | null => getPortfolioRoot(state).reportEmail;
